import type React from 'react';

import { Button } from '@change/ds-core-ui/Button';
import { HeroLayout } from '@change/ds-core-ui/HeroLayout';
import { Image } from '@change/ds-core-ui/Image';
import { Text } from '@change/ds-core-ui/Text';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import victoryFlagDarkUrl from '#src/assets/victory-flag-dark.png';
import victoryFlagUrl from '#src/assets/victory-flag.png';

import { Waypoint } from '#src/app/shared/components/scroll';

import { useContributeSection } from './hooks/useContributeSection';

export const ContributeSection: React.FC<EmptyProps> = () => {
	const { translate } = useI18n();
	const {
		actions: { onCtaClick, onSectionView },
	} = useContributeSection();

	return (
		<HeroLayout
			variant="1/2"
			data-testid="homepage-contribute-section"
			reverseMd
			className="bg-background-raised text-typography-strong"
			media={
				<div className="bg-background-overlay md:bg-background-raised h-full">
					<Image
						alt={translate('corgi.homepage.contribute_section.image.alt_text_group')}
						src={victoryFlagUrl}
						loading="lazy"
						className="h-full w-full object-contain dark:hidden"
					/>
					<Image
						alt={translate('corgi.homepage.contribute_section.image.alt_text_group')}
						src={victoryFlagDarkUrl}
						loading="lazy"
						className="hidden h-full w-full object-contain dark:block"
					/>
				</div>
			}
		>
			<div className="flex flex-col items-start gap-5 p-6 md:gap-6 md:p-12">
				<div>
					<Waypoint onEnter={onSectionView} />
					<Text as="h2" data-qa="contribute-section-title" variant="heading" size="large">
						<Translate value="corgi.homepage.contribute_section.title_alt" />
						<br />
						<Translate value="corgi.homepage.contribute_section.subtitle_alt" />
					</Text>
				</div>

				<Text variant="body">
					<Translate value="corgi.homepage.contribute_section.description_alt" />
				</Text>

				<Button data-qa="homepage-contribute-section-cta" onClick={onCtaClick} as="a" href="/member/join">
					<Translate value="corgi.homepage.contribute_section.cta_btn" />
				</Button>
			</div>
		</HeroLayout>
	);
};
